<script lang="ts">
    import { Button, Col, Form, FormGroup, Input, InputGroup, InputGroupText, Label, Row } from "sveltestrap";
    import { BasicInputgroups, Cancel, JointAddon, LeftAddon, LeftRightAddon, Raisestyle, RightAddon, Solidstyle, Flatstyle, Submit } from "../../../../utils/Constant/Constant";
    import Card from "../../../Core/Card.svelte";
</script>
<Card cardHeaderprops="pb-0" headerTitle={BasicInputgroups}>
  <div slot=contentbody>
    <Row>
      <Col>
        <Form>
          <FormGroup class="m-form__group">
            <Label>{LeftAddon}</Label>
            <InputGroup>
              <InputGroupText><i class="icofont icofont-pencil-alt-5"></i></InputGroupText>
              <Input placeholder="Email" />
            </InputGroup>
          </FormGroup>
          <FormGroup>
            <Label>{RightAddon}</Label>
            <InputGroup>
              <Input placeholder="Recipient's username" />
              <InputGroupText><i class="icofont icofont-ui-dial-phone"> </i></InputGroupText>
            </InputGroup>
          </FormGroup>
          <FormGroup>
            <Label>{JointAddon}</Label>
            <InputGroup>
              <InputGroupText><i class="icofont icofont-unlink"></i></InputGroupText>
              <InputGroupText>0.00</InputGroupText>
              <Input  />
            </InputGroup>
          </FormGroup>
          <FormGroup>
            <Label>{LeftRightAddon}</Label>
            <InputGroup>
              <InputGroupText><i class="icon-zoom-out"></i></InputGroupText>
              <Input  />
              <InputGroupText><i class="icon-zoom-in"></i></InputGroupText>
            </InputGroup>
          </FormGroup>
          <FormGroup class="input-group-solid">
            <Label>{Solidstyle}</Label>
            <InputGroup>
              <InputGroupText><i class="icofont icofont-users"> </i> </InputGroupText>
              <Input placeholder="999999" />
            </InputGroup>
          </FormGroup>
          <FormGroup class="input-group-square">
            <Label>{Flatstyle}</Label>
            <InputGroup>
              <InputGroupText><i class="icofont icofont-credit-card"> </i></InputGroupText>
              <Input placeholder="" />
            </InputGroup>
          </FormGroup>
          <FormGroup class="input-group-square">
            <Label>{Raisestyle}</Label>
            <InputGroup>
              <InputGroupText><i class="fa fa-download"></i></InputGroupText>
              <Input placeholder="https://www.example.com" />
            </InputGroup>
          </FormGroup>
          <FormGroup>
            <Label>{LeftRightAddon}</Label>
            <InputGroup>
              <InputGroupText><i class="icofont icofont-ui-copy"> </i> </InputGroupText>
              <Input placeholder="Email" />
              <InputGroupText><i class="icofont icofont-stock-search"> </i></InputGroupText>
            </InputGroup>
          </FormGroup>
        </Form>
      </Col>
    </Row>
  </div>
  <div slot="contentfooter">
    <Button color="primary" class="m-r-15" type="submit">{Submit}</Button>
    <Button color="light" type="submit">{Cancel}</Button>
  </div>
</Card>               